import router from '@/router'
import { createLogger } from 'vuex'
import { getStorage, removeStorage } from '@/lib/utility'

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = ''
  }

  if (to.path.includes('qiyuEquipment')) {
    removeStorage('isLogin')
    removeStorage('userInfo')
  }
  if (to.path.includes('equipment')) {
    removeStorage('isQiyuLogin')
    removeStorage('qiyuUserInfo')
  }

  if (to.meta.equipmentLogin) {
    if (getStorage('isLogin') && getStorage('userInfo')) {
      next()
    } else {
      next({
        path: '/equipment/login'
      })
    }
  } else if (to.meta.qiyuEquipmentLogin) {
    if (getStorage('isQiyuLogin') && getStorage('qiyuUserInfo')) {
      next()
    } else {
      next({
        path: '/qiyuEquipment/login'
      })
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})
